import { useEffect, useState } from 'react';
import { instance } from 'utils/axiosConfig';
import { Footer, Header, ILibrary, Library } from 'components';
import { ItemType } from 'types';
import { useTranslation } from 'react-i18next';

import cn from 'classnames';

import styles from './Dashboard.module.scss';

import { changeLanguage } from 'i18next';

export const Dashboard = () => {
  const [videoLibs, setVideoLibs] = useState<ILibrary[]>([]);
  const [reportLibs, setReportLibs] = useState<ILibrary[]>([]);

  const language = localStorage.getItem('i18nextLng');

  const { t } = useTranslation();

  useEffect(() => {
    instance
      .get('/reports', {
        headers: {
          'Accept-Language': language
        }
      })
      .then(res => {
        setReportLibs(res.data.data);
      });
    instance
      .get('/videos', {
        headers: {
          'Accept-Language': language
        }
      })
      .then(res => {
        setVideoLibs(res.data.data);
      });
  }, [language]);

  useEffect(() => {
    instance.get(`/users/me`).then(response => {
      const userLanguage = response.data.data.language;
      changeLanguage(userLanguage);
    });
  }, []);

  const checkIsDataEmpty = () => {
    if (!videoLibs.length && !reportLibs.length) {
      return (
        <div className={styles.emptyData}>
          <div className={styles.emptyDataText}>{t('No data')}</div>
        </div>
      );
    }
    return false;
  };

  const isLibraryNonEmpty = (library: ILibrary) => {
    if (library) {
      if (library.categories.length) {
        return true;
      } else if (library.libraries.length) {
        for (let i = 0; i < library.libraries.length; i++) {
          if (isLibraryNonEmpty(library.libraries[i])) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const renderReports = libraries => {
    return (
      <>
        {libraries?.map((library, index) => (
          <Library
            key={index}
            title={library.title}
            type={ItemType.Report}
            categories={library.categories}
          >
            {library.libraries.length > 0 && renderReports(library.libraries)}
          </Library>
        ))}
      </>
    );
  };

  const renderVideos = libraries => {
    return (
      <>
        {libraries?.map((library, index) => (
          <Library
            key={index}
            title={library.title}
            type={ItemType.Video}
            categories={library.categories}
          >
            {library.libraries.length > 0 && renderVideos(library.libraries)}
          </Library>
        ))}
      </>
    );
  };

  const getLibsCount = () => {
    return (
      videoLibs.filter(library => isLibraryNonEmpty(library)).length +
      reportLibs.filter(library => isLibraryNonEmpty(library)).length
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <Header />
        <div
          className={(libsCount => {
            return cn(
              styles.lists,
              libsCount === 1 ? styles.listsOneGrid : '',
              libsCount === 2 || libsCount === 4 ? styles.listsTwoGrid : '',
              libsCount === 3 || libsCount >= 5 ? styles.listsThreeGrid : ''
            );
          })(getLibsCount())}
        >
          {checkIsDataEmpty()}
          {renderReports((reportLibs || []).filter(library => isLibraryNonEmpty(library)))}
          {renderVideos((videoLibs || []).filter(library => isLibraryNonEmpty(library)))}
        </div>
        <Footer />
      </div>
    </div>
  );
};
